import { Array, Number, Record, String, Boolean } from "runtypes";

export const UserPayment = Record({
  id: String,
  firstName: String,
  lastName: String,
  maskedCardNumber: String,
  cardType: String,
  expirationMonth: Number,
  expirationYear: Number,
  billingAddress: String,
  billingAddress2: String,
  billingCity: String,
  billingState: String,
  billingZip: String,
  billingCountry: String,
  isDefault: Boolean,
});

// The response is an array of payments
export const UserPaymentsResponse = Array(UserPayment);
